import BaseApi from './base/BaseApi';
import { PostOperation } from './base/operations';

export default class extends BaseApi {
  static entityName = 'tariffs';

  select(id, withPreloader = false) {
    const operation = new PostOperation(`/api/tariffs/${id}/select`, []);
    return this.execute(operation, withPreloader);
  }
}
